import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";
import LoadingButtonWithTooltip from "../Common/LoadingButtonWithTooltip";
import TaskIcon from '@mui/icons-material/Task';
export default function EditMandateDialog(props) {

    const handleClose = () => {
        props.onClose();
    };


    const compl = () => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/c4ad28b2d72340d49dbe27fb1b64c701/" + props.state.params.uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":

                        window.location.href = "/11d1355181ac4376a09980601b420617/" + props.state.params.uid
                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };


    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog"><Typography variant="h5" gutterBottom>Etablir le mandat de vente</Typography></DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    Confirmez-vous que tous les vendeurs sont bien présents?
                </Typography>
                <Typography variant="h5" gutterBottom>
                    Le mandat sera émis immédiatement en cas de réponse positive.
                </Typography>


            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
                    <Box>
                        <Button variant="contained" onClick={handleClose} style="margin: 10px;">
                            Non
                        </Button>
                    </Box>
                    <Box>
                        <LoadingButtonWithTooltip icon={<TaskIcon />} label={"OUI"} click={compl} />
                    </Box>

                </Box>
            </DialogActions>
        </Dialog>
    );
}
